// Base API URL - dev
export const GQL_BASE_URL = process.env.API_URL
    ? process.env.API_URL
    : 'https://stg.api.opendata.litterati.org'; // 'http://litteratiopendatadev-api.d94mnwdgbb.us-west-1.elasticbeanstalk.com';
